import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionSubTypeIdEnum, QuestionTypeIdEnum, ScoringTypeEnum, ItemStatusEnum } from '@configs/questions.config';
import { CreateNewItemComponent } from '@items/create-new-item/create-new-item.component';
import { ItemPreviewComponent } from '@items/item-preview/item-preview.component';
import { TranslateService } from '@ngx-translate/core';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { RoleManagementService } from '@services/role.management.service';
import { WebErrorService } from '@services/webError.service';
import { Subject, Subscription } from 'rxjs';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-question-list-details',
  templateUrl: './question-list-details.component.html',
  styleUrls: ['./question-list-details.component.scss']
})
export class QuestionListDetailsComponent implements OnInit {
  id: any;
  element1: void;
  flag: boolean = false;
  flag1: boolean = true;
  buttonWasClicked: boolean = false;
  backButtonFlag: boolean = true;
  displaydata: any;

  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;

  displayedColumns: string[] = ['itemBankName', 'itemDescription'];
  itemuuid: any;
  isEdit: boolean = false;
  getitemuuid: any;
  dataSource: any;
  itemId: any;
  questions: any;
  itemdetails: any;
  numberOfQuestions = 0;
  data: any;
  itemBasicData: any;
  isPublished = false;
  selectedTabIndex = 0;
  itemBasicDetails = {
    itemBankName: '',
    itemDescription: '',
    collectionId: '',
    itemBankId: '',
    isPublished: false,
  };
  setP: boolean;
  questionId: any;
  collectionId: any;
  testId: any;
  itemBankNameDisplay: any;
  itemBankNameDiscription: any;
  isNoQuestions = false;
  newItemname: any;
  ItemIdQue: any;
  dataAvailable: boolean = false;
  spinner: boolean = true;
  questionSubtypeId: any;
  questionTypeId: any;
  itemsDetailsSubscription: Subscription;
  updateItemSubscription: Subscription;
  editItemSubscription: Subscription;
  backButtonSubscription: Subscription;
  styleGroupSubscription: Subscription;
  ItemBasicDetailsSubscription: Subscription;
  routeSubscription: Subscription;
  @ViewChild('table') table: MatTable<any>;
  @ViewChild('itemPreview') itemPreview: ItemPreviewComponent;
  @Output() numberOfQuestion: EventEmitter<number> = new EventEmitter();
  ScoringTypeEnum = ScoringTypeEnum;
  ItemStatusEnum = ItemStatusEnum;
  StyleList: any;
  itemStatusList: any = [];
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private itemservice: ItemService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private questionService: QuestionService,
    private dialog: MatDialog,
    public roleSer: RoleManagementService,
    private notificationService: NotificationService,
    private webErrorService: WebErrorService,
    public translate: TranslateService,
    public snackBar: MatSnackBar
  ) {
    this.translate.stream('items.statusArray').pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
      this.itemStatusList = translation;
    });

    this.ItemBasicDetailsSubscription = this.itemservice.ItemBasicDetails.subscribe(data => {

      if (data.scoringTypeId === ScoringTypeEnum.On180360Degree) {
        let itemuuid = data.itemuuId == undefined ? data.itemuuid : data.itemuuId;
        let styleGroupid = data.styleGroupid == undefined ? data.stylegroupid : data.styleGroupid;
        this.styleGroupSubscription = this.itemservice.getStylesBasedOnStyleGroup(itemuuid, styleGroupid).subscribe(styles => {
          this.StyleList = styles.data;
          this.itemservice.StyleList.next(styles.data);
        },
        (error) => {this.styleGroupSubscription.unsubscribe();});
      }

    },
    (error) => {this.ItemBasicDetailsSubscription.unsubscribe();});
  }

  @Input() set itemDetails(data) {
    this.backButtonSubscription = this.questionService.backButtonObs.subscribe(showBtnStatus => {
      if (showBtnStatus != '') {
        this.questions = '';
        console.log('backButtonObs question list details')
        this.id = data?.data?.scoringTypeId
        this.flag = !showBtnStatus;
        this.backButtonSubscription.unsubscribe();
        this.getItemDetails(data);
        this.dataAvailable = !showBtnStatus;
        this.isEdit = !showBtnStatus;
        this.buttonWasClicked = !showBtnStatus;
      }
    });

    this.spinner = false;
    this.itemId = sessionStorage.getItem('itemuuidId') //this.activatedRoute.snapshot.paramMap.get('id');
    this.itemservice.updateStatus.subscribe((isItemDisable) => {
      if (isItemDisable) {
        this.isPublished = isItemDisable;
      }
      this.displaydata = sessionStorage.backbtnflag;
    });
    this.collectionId = sessionStorage.defaultcollectionid;

    if (data != undefined) {
      console.log('input question list details')
      this.getItemDetails(data);
    }
  }

  ngOnInit(): void {
    const scoringTypeId = sessionStorage.getItem('scoringTypeId');
    this.itemservice.ScoringTypeId.next(scoringTypeId);
  }


  getItemDetails(data: any) {
    this.itemId = sessionStorage.getItem('itemuuidId') //this.activatedRoute.snapshot.paramMap.get('id');
    this.itemservice.getItemDetails(this.itemId).subscribe((resdata) => {
      console.log('getItemDetails question list details')
      this.backButtonSubscription.unsubscribe();
      this.getitemuuid = resdata?.data?.itemuuId;
      this.itemservice.getItemuuid(this.getitemuuid);
      this.itemBankNameDisplay = resdata?.data?.itemBankName;
      this.itemBankNameDiscription = resdata?.data?.itemDescription;
      this.prepareTableData(resdata);
      if (resdata?.data?.questions > 1) {
        this.isNoQuestions = true;
      } else {
        this.questions = new MatTableDataSource(resdata?.data?.questions.sort((a, b) => (a.questionOrder - b.questionOrder)));
      }
      this.questionService.backButtonObs.next('')
    });

  }

  prepareTableData(itemBasicData: any) {
    this.numberOfQuestions = itemBasicData?.data?.questions?.length;
    if (this.numberOfQuestions == 0) { this.dataAvailable = true; this.flag = false; } else {
      this.dataAvailable = false; this.spinner = true;
    }
    this.questions = new MatTableDataSource(itemBasicData?.data?.questions.sort((a, b) => (a.questionOrder - b.questionOrder)));
    this.itemBasicDetails['itemBankName'] = itemBasicData?.data?.itemBankName;
    this.itemBasicDetails.itemDescription =
      itemBasicData?.data?.itemDescription;
    this.itemBasicDetails.collectionId = this.collectionId;
    this.itemBasicDetails.itemBankId = itemBasicData?.data?.itemBankId;
    this.ItemIdQue = this.itemBasicDetails.itemBankId;
    if (itemBasicData?.data?.statusId == ItemStatusEnum.Published) {
      this.isPublished = true;
      this.itemBasicDetails.isPublished = true;
    } else {
      this.isPublished = false;
      this.itemBasicDetails.isPublished = false;
    }
  }


  openNewItemDialog(): void {
    this.dialog.open(CreateNewItemComponent, { minWidth: '650px', data: { itemuuid: this.getitemuuid, itemBasicDetails: this.itemBasicDetails } });
  }

  toggle(clicked: boolean) {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      this.buttonWasClicked = clicked;
      this.dataAvailable = !clicked;
      this.flag = true;
      sessionStorage.removeItem('questionId');
      sessionStorage.removeItem('questionuuId');
      this.itemservice.selectedQuestionTab.next('tab1');
    }
  }

  editQuestion(ele: any) {
    if(!this.isPublished && this.roleSer.accessData && (this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed)){
      this.isEdit = true;
      this.element1 = ele;
      this.questionSubtypeId = ele.questionSubtypeId;
      this.questionTypeId = ele.questionTypeId;
      sessionStorage.setItem('questionId', ele.questionid);
      sessionStorage.setItem('questionuuId', ele.questionuuId);
    }
  }

  deleteQuestion(questions: any) {
    if(!this.isPublished && this.roleSer.accessData && (this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed)){
      const dialogRef = this.dialog.open(DelMessageComponent, {
        data: {
          message: this.translate.instant('itemDetails.TabQuestions.deletePopup.message'),
          buttonText: {
            ok: this.translate.instant('itemDetails.TabQuestions.deletePopup.btnYes'),
            cancel: this.translate.instant('itemDetails.TabQuestions.deletePopup.btnNo')
          } } });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.questionId = questions.questionuuId;
          this.questionService
            .deleteQuestion(this.questionId, this.itemId)
            .subscribe((d) => {
              this.questions = new MatTableDataSource(this.questions?.data.filter(q => q.questionuuId != this.questionId));
              this.itemservice.questionCountUpdate.next(this.questions?.data?.length);
              // this.questionService.reloadList.next(true);
              this.notificationService.success(d.message);
            }, (error: any) => {
              this.webErrorService.handleAPIErrors(error, null, true, 'warn');
            });
        }
      });
    };
  }

  navigateToSelectQuestionsType() {
    sessionStorage.setItem('ItemIdQue', this.ItemIdQue);
    this.router.navigate(['./selectquestiontype'], {
      relativeTo: this.activatedRoute,
      state: { itemId: this.itemId },
    });
  }
  navigateToItemLanding() {
    sessionStorage.removeItem('TestId');
    sessionStorage.removeItem('ItemIdQue');
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }

  openDialogPreview(): void {
    this.itemPreview.showPopup({ name: this.questions, id: this.itemId });
  }

  onPostAdded(event) {
    this.isEdit = event === 'false' ? false : true;
    this.questionService.backButtonObs.next(true);
  }

  dropTable(event: CdkDragDrop<any[]>) {
    if (!this.isPublished) {
      const prevIndex = this.questions.data.findIndex((d: any) => d === event.item.data);
      moveItemInArray(this.questions.data, prevIndex, event.currentIndex);
      // this.questions = new MatTableDataSource(this.dragdropdata)
      let payload = [];


      this.questions.data.forEach((a, index) => {
        let que = { questionid: a.questionid, questionorder: index + 1 };
        payload.push(que);
      });

      this.itemservice.arrangeOrder(this.getitemuuid, payload).subscribe((data) => {
        this.getItemDetails('');
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    }
  }

  ngOnDestroy() {
    if (this.itemsDetailsSubscription) {
      this.itemsDetailsSubscription.unsubscribe();
    }
    if (this.updateItemSubscription) {
      this.updateItemSubscription.unsubscribe();
    }
    if (this.editItemSubscription) {
      this.editItemSubscription.unsubscribe();
    }
    if (this.backButtonSubscription) {
      this.backButtonSubscription.unsubscribe();
    }
    if (this.styleGroupSubscription) {
      this.styleGroupSubscription.unsubscribe();
    }
  }
}
